import { Seo } from "@/components/layout/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { SectionIntro } from "@/components/sections/SectionIntro";
import { OfferingGrid } from "@/components/sections/OfferingGrid";
import { ImageFeature } from "@/components/sections/ImageFeature";
import { CtaBand } from "@/components/sections/CtaBand";
import { SOLUTIONS } from "@/content/offerings";
import { enquire } from "@/content/navigation";

export default function Solutions() {
  const consult = enquire("VION AI Solutions");
  return (
    <>
      <Seo title="VION AI Solutions | AI Agents, Automation & Digital Transformation" description="VION AI Solutions helps businesses and institutions use AI agents, automation, AI integration and digital transformation to work smarter." path="/ai-solutions" />
      <PageHero
        testid="solutions-hero"
        eyebrow="VION AI Solutions"
        lines={["Helping Organisations", "Work Smarter", "With AI."]}
        accentLine={2}
        intro="We help businesses and institutions use AI, automation and technology to improve productivity, efficiency and the way work gets done."
        image="/images/solutions-hero.webp"
        alt="Business team discussing a digital transformation project in a modern office"
        shape="notch"
        actions={[
          { label: "Request a Consultation", to: consult, testid: "solutions-consult-btn" },
          { label: "Partner With Us", to: "/partnerships", variant: "outline", testid: "solutions-partner-btn" },
        ]}
      />
      <section className="bg-ivory py-24 text-ink sm:py-32" data-testid="solutions-services">
        <div className="shell">
          <SectionIntro tone="light" eyebrow="Services" title={<>Practical AI for <em className="text-plum-2">real operations.</em></>}>
            <p>Every engagement starts with understanding your goals, processes and constraints.</p>
          </SectionIntro>
          <div className="mt-16">
            <OfferingGrid items={SOLUTIONS} tone="light" prefix="solution" ctaLabel="Request a Consultation" ctaHref={(s) => enquire("VION AI Solutions", s.title)} />
          </div>
        </div>
      </section>
      <ImageFeature
        tone="dark"
        reverse
        testid="solutions-feature"
        image="/images/solutions-2.webp"
        alt="Professional working on an automation project at a laptop"
        eyebrow="Our Approach"
        title="Technology that fits the way you work."
        text={["We focus on solutions that are practical to adopt, easy for teams to use and aligned with your organisation's priorities.", "Whether you are exploring AI for the first time or scaling existing systems, we help you move forward with clarity."]}
        actions={[{ label: "Request a Consultation", to: consult, testid: "solutions-feature-consult-btn" }]}
      />
      <CtaBand testid="solutions-cta" eyebrow="Work Smarter" title="Ready to put AI to work?" text="Tell us about your organisation and the challenges you'd like to solve." primary={{ label: "Request a Consultation", to: consult }} secondary={{ label: "Partner With Us", to: "/partnerships" }} />
    </>
  );
}
